(() => {
  // Keep Rebuy SmartCart closed when ShipTection's /cart/change re-opens it after
  // the user closed it. Allow opens that follow a real user gesture; suppress the
  // rest within a short window after a close.
  const GESTURE_WINDOW_MS = 2500;
  const REOPEN_SUPPRESS_MS = 3000;
  let lastUserGesture = 0;
  let suppressReopenUntil = 0;

  const now = () => performance.now();

  const armSuppression = () => {
    suppressReopenUntil = now() + REOPEN_SUPPRESS_MS;
  };

  const markUserGesture = (event) => {
    if (event.isTrusted) lastUserGesture = now();
  };

  const hideSmartCart = () => {
    const smartCart = window.Rebuy?.SmartCart;
    if (!smartCart) return;
    if (typeof smartCart.hide === 'function') smartCart.hide();
    else if (typeof smartCart.close === 'function') smartCart.close();
  };

  const onSmartCartHide = () => {
    // A close (user or programmatic) arms the suppression window and
    // invalidates the closing gesture so it can't authorize a reopen.
    armSuppression();
    lastUserGesture = 0;
  };

  const onSmartCartShow = (event) => {
    const t = now();
    const hasRecentGesture = t - lastUserGesture <= GESTURE_WINDOW_MS;
    if (t >= suppressReopenUntil || hasRecentGesture) return;

    // Programmatic reopen (e.g. ShipTection cart change) — keep it closed.
    armSuppression();
    if (event?.cancelable) event.preventDefault();
    hideSmartCart();
  };

  const init = () => {
    document.addEventListener('pointerdown', markUserGesture, true);
    document.addEventListener('keydown', markUserGesture, true);
    document.addEventListener('rebuy:smartcart.hide', onSmartCartHide);
    document.addEventListener('rebuy:smartcart.show', onSmartCartShow);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
